/** Shared daily challenge: fixed question count, same set for everyone that UTC day. */
export const DAILY_CHALLENGE_LENGTH = 10;
export const DIFFICULTIES = ['easy', 'medium', 'hard'];
export const TIMED_DURATIONS_SEC = [90, 120];
export const ANSWER_WINDOW_MS = 5000;
export const STARTING_LIVES = 3;
export const MAX_MP_PLAYERS = 5;
export const MIN_MP_PLAYERS = 2;
/** Shared time-bank solo mode */
export const TIME_BANK_START_MS = 60_000;
export const TIME_BANK_CORRECT_MS = 2_000;
export const TIME_BANK_WRONG_MS = 3_000;
/** Reading beat before answers (scaled by prompt length). */
/** Question-only preview before answers unlock. */
export const READING_MS_MIN = 1_000;
export const READING_MS_MAX = 2_000;
/** Word counts that map to min/max reading time. */
export const READING_WORDS_AT_MIN = 3;
export const READING_WORDS_AT_MAX = 14;
/** @deprecated use readingMsForPrompt — mid-length fallback */
export const READING_MS = 1_200;
export function countWords(text) {
    return text.trim().split(/\s+/).filter(Boolean).length;
}
/** Preview time from prompt length, clamped to 0.5–2s. */
export function readingMsForPrompt(prompt) {
    const words = countWords(prompt);
    if (words <= READING_WORDS_AT_MIN)
        return READING_MS_MIN;
    if (words >= READING_WORDS_AT_MAX)
        return READING_MS_MAX;
    const t = (words - READING_WORDS_AT_MIN) / (READING_WORDS_AT_MAX - READING_WORDS_AT_MIN);
    return Math.round(READING_MS_MIN + t * (READING_MS_MAX - READING_MS_MIN));
}
/** Correct answers in a row needed to step difficulty up one tier. */
export const STREAK_UP_THRESHOLD = 3;
export function isTimedDuration(n) {
    return TIMED_DURATIONS_SEC.includes(n);
}
//# sourceMappingURL=quiz.js.map